import styled from 'styled-components';

import TestimonialQuote from '@klv/organisms/testimonials-quote';
import * as styles from '@klv/organisms/testimonials-quote/styles/testimonialsQuote.module.scss';
import Grid from '@klv/utils/grid';

import { calculateWidthFromColumns } from '@klv/shared/utils/functions';

import type { TColorVariant } from '@klv/shared/styles/types';

export const Container = styled.div<{ $backgroundColor: TColorVariant; }>`
  ${({ $backgroundColor, theme }) => `
    background-color: ${theme.testimonialsTwoColumn[$backgroundColor].backgroundColor};
    ${theme.globalPadding}

    .${styles.testimonialQuote} {
      background-color: ${theme.testimonialsTwoColumn[$backgroundColor].backgroundColor};
    }
  `}
`;

export const TwoColumnStyledGrid = styled(Grid)`
`;

export const StyledTestimonialsTwoColumn = styled(TestimonialQuote)`
  grid-column: 1 / -1;
  padding: 0;
  margin-bottom: 4rem;

  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      grid-column: 2 / -1;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      display: flex;
      align-items: center;
      grid-column: 1 / 9;
      margin-bottom: 0;
    }
  `}

  &&& {
    .${styles.grid} {
      padding: 0;
      display: block;
    }

    .${styles.textWrapper} {
      text-align: left;
      width: 100%;
      padding: 0;

      ${({ theme }) => `
        ${theme.screenSize.s576.mediaQuery} {
          padding-left: ${calculateWidthFromColumns(1.2, 13)};
        }
        ${theme.screenSize.s768.mediaQuery} {
          padding-left: 0;
        }
        ${theme.screenSize.s1024.mediaQuery} {
          margin-right: 6.4rem;
          padding-left: ${calculateWidthFromColumns(1.2, 8)};
          padding-right: 2.4rem;
        }
        ${theme.screenSize.s1200.mediaQuery} {
          padding-left: ${calculateWidthFromColumns(1, 8)};
          padding-right: 0;
        }
      `}
    }

    .${styles.icon} {
      ${({ theme }) => `
        ${theme.screenSize.s576.mediaQuery} {
          position: absolute;
          left: -4.2rem;
        }
        ${theme.screenSize.s768.mediaQuery} {
          left: calc(-4.2rem - 2rem);
        }
        ${theme.screenSize.s1024.mediaQuery} {
          left: 0rem;
        }
        ${theme.screenSize.s1200.mediaQuery} {
          left: 0;
        }
      `}
    }
  }
`;
